import { render } from "./storage.vue?vue&type=template&id=41cadebd"
import script from "./storage.vue?vue&type=script&lang=js"
export * from "./storage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__